// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2064":"a546c7b7d90d089e","9705":"71d4abe22a6cdc26","9827":"627e5812efa4ff4e"}[chunkId] + ".js";
};